<template>
    <!-- Modal copy parameters -->
    <modal v-if="copyModal" @close="copyModal = false">
        <template slot="header">
            <h4 class="modal-title">Copiar parâmetros</h4>
            <md-button
                class="md-simple md-just-icon md-round modal-default-button"
                @click="copyModal = false"
            >
                <md-icon>clear</md-icon>
            </md-button>
        </template>

        <template slot="body">
            <div class="md-layout">
                <div
                    class="md-layout-item md-layout md-size-100 md-alignment-top-space-between"
                    style="overflow-x: visible;"
                >
                    <div
                        class="md-layout-item md-size-100"
                        style="overflow-x: visible;"
                    >
                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            style="overflow-x: visible; margin-bottom: 7px;"
                        >
                            <label class="artificial-label">
                                Produto Similar
                            </label>
                            <vue-simple-suggest
                                v-model="similarProductModel"
                                :list="similarProductsList"
                                :debounce="500"
                                display-attribute="name"
                                value-attribute="id"
                                @select="similarProductSelected"
                                :disabled="copyLoading"
                            >
                            </vue-simple-suggest>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template slot="footer">
            <md-button class="md-simple" @click="copyModal = false">
                Voltar
            </md-button>
            <md-button
                class="md-primary"
                @click="similarProductSubmit()"
                :disabled="copyLoading || !similarProductToCopy"
            >
                <i class="fas fa-spinner fa-spin" v-if="copyLoading"></i>
                Confirmar
            </md-button>
        </template>
    </modal>
</template>

<script>
import { mapActions } from 'vuex'
import VueSimpleSuggest from 'vue-simple-suggest'
import { Modal } from '@/components'
import { ProductService } from '@/services/product.service'
import { SimulationService } from '@/services/simulation.service'

export default {
    props: {
        baseStore: { type: String, required: true },
        simulation: {
            type: Object,
            default: null
        }
    },
    components: {
        Modal,
        VueSimpleSuggest
    },
    created() {
        this.readParameters = function() {
            this.$store.dispatch.apply(null, [
                this.baseStore + '/read',
                ...arguments
            ])
        }
    },
    data() {
        return {
            copyModal: false,
            copyLoading: false,

            selectedBranches: [],

            similarProductModel: '',
            similarProductToCopy: null,

            // dynamic methods
            readParameters: null
        }
    },
    methods: {
        ...mapActions('simulations', {
            createClone: 'createClone'
        }),

        // SIMILAR PRODUCT MODAL
        similarProductModalOpen(selectedBranches) {
            this.selectedBranches = selectedBranches
            this.copyModal = true
        },
        async similarProductsList() {
            let products = await ProductService.read({
                q: this.similarProductModel,
                except: this.simulation.product
            })
                .then(res => res.data)
                .then(json => json.results)
            products = products.map(item => {
                item.name = item.external_id + ' - ' + item.name
                return item
            })
            return products
        },
        similarProductSelected(selectedItem) {
            this.similarProductToCopy = selectedItem.id
        },
        async similarProductSubmit() {
            this.copyLoading = true

            if (!this.simulation.clone)
                await this.createClone(this.simulation.id)

            try {
                await SimulationService.copyBranchParameters(
                    this.simulation.clone,
                    this.similarProductToCopy,
                    this.selectedBranches
                )
            } catch (err) {
                this.$notify({
                    message: 'Erro ao copiar parâmetros.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })
                this.copyLoading = false
                return
            }
            this.$notify({
                message: 'Parâmetros copiados com sucesso!',
                icon: 'add_alert',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'success'
            })
            await this.readParameters({
                simulation: this.simulation.clone
                    ? this.simulation.clone
                    : this.simulation.id
            })
            this.copyLoading = false
            this.copyModal = false
        }
    }
}
</script>
